import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GeneralType, Quest } from "../../../../lib/types";
import GeneralCard from "./GeneralCard";
import GeneralEmptyCard from "./GeneralEmptyCard";
import GeneralDetail from "./GeneralDetail";
import { setSameHeight } from "../../../../lib/elementUtilities";
import { DragescentState } from "../../../../store/reducers/stateType";
import { finishQuest } from "../../../../store/actions";

const Generals = () => {
  const [openDetail, setOpenDetail] = useState<number | null>(null);
  const cardsRef = useRef<HTMLDivElement>(null);

  const generals = useSelector((state: DragescentState) => state.governorate.generals);
  const development = useSelector((state: DragescentState) => state.governorate.development);
  const availableQuests = useSelector(
    (state: DragescentState) => state.governorate.availableQuests
  );
  const finishedQuests = useSelector((state: DragescentState) => state.governorate.finishedQuests);
  const dispatch = useDispatch();

  useEffect(() => {
    setSameHeight(cardsRef.current || undefined);
  }, [generals]);
  const generalsCount = generals
    .reduce((count: number, generalType: GeneralType) => count += generalType.general ? 1 : 0, 0);

  return (
    <>
      <section className="boxes-group">
        <div className="box first text-center padding">
          <div className="row persons generals" ref={cardsRef}>
            {generals.map((generalType: GeneralType) => (generalType.general
              ? <GeneralCard
                key={generalType.general.id}
                general={generalType.general}
                typeId={generalType.typeId}
                typeName={generalType.typeName}
                selected={openDetail === generalType.general.id}
                // @ts-ignore
                showDetail={() => {
                  if (availableQuests?.some((q: Quest) => q.id === 13)
                    && !finishedQuests?.some((q: Quest) => q.id === 13)) {
                    dispatch(finishQuest(13));
                  }
                  if (generalType.general) {
                    setOpenDetail(generalType.general.id);
                  }
                }}
              />
              : <GeneralEmptyCard
                key={generalType.typeName}
                typeId={generalType.typeId}
                typeName={generalType.typeName}
                sendToLabyrinth={true}
                zeroGenerals={!generalsCount}
              />))}
          </div>
        </div>
        <span className="divider"/>
      </section>
      {
        openDetail
        && <GeneralDetail
          general={generals
            .find((g: GeneralType) => g.general && g.general.id === openDetail).general}
          typeName={generals
            .find((g: GeneralType) => g.general && g.general.id === openDetail).typeName}
          typeId={generals
            .find((g: GeneralType) => g.general && g.general.id === openDetail).typeId}
          techPoints={development.points}
        />
      }
    </>
  )
}

export default Generals;
